
import React from 'react';
import styles from './styles';

export const TypingIndicator = () => (
  <div className="flex space-x-2 items-center">
    <div className={`w-2 h-2 ${styles.typingIndicator.dot} rounded-full animate-bounce`}></div>
    <div className={`w-2 h-2 ${styles.typingIndicator.dot} rounded-full animate-bounce`} style={{animationDelay: '0.2s'}}></div>
    <div className={`w-2 h-2 ${styles.typingIndicator.dot} rounded-full animate-bounce`} style={{animationDelay: '0.4s'}}></div>
  </div>
);

export const BackgroundEffects = () => (
  <div className="absolute inset-0 overflow-hidden pointer-events-none">
    <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-transparent to-gray-50 opacity-50"></div>
    <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-blue-500 to-transparent opacity-20"></div>
    <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-blue-500 to-transparent opacity-20"></div>
  </div>
);

export default {
  TypingIndicator,
  BackgroundEffects
}; 